// src/components/MagaluAuthentication.js
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Navbar from '../../components/navbar/navbar.jsx'
import apinode from '../../services/apinode.js';
import { toast } from 'react-toastify'

const MagaluAuthentication = () => {
    const [code, setCode] = useState('');
    const [seller, sellerId] = useState('');
    let params = {}

    // Função para extrair o código da URL
    useEffect(() => {
        const url = window.location.href;
        const urlParams = new URLSearchParams(url.split('?')[1]);
        const codeParam = urlParams.get('code');
        const seller_id = urlParams.get('state');
        setCode(codeParam);
        const params = extractParamsFromUrl(url)
        sellerId(params)

    }, []);

    const extractParamsFromUrl = (url) => {
        const urlParams = new URLSearchParams(url.split('?')[1]);

        // Verificar se há o parâmetro 'state' na URL
        if (urlParams.has('state')) {
            const stateParam = urlParams.get('state');

            // Dividir o parâmetro 'state' em partes usando o '&' como delimitador
            const stateParts = stateParam.split('&');

            // Procurar por 'seller_id' dentro das partes divididas
            for (const part of stateParts) {
                if (part.includes('seller_id')) {
                    // Dividir novamente para obter o valor de 'seller_id'
                    const sellerId = part.split('=')[1];
                    return sellerId;
                }
            }
        }

         // Se não encontrar 'seller_id' na URL
        return null;
    };

    // Função para fazer a requisição ao Magalu
    const handleAuthentication = async () => {
        console.log(seller)

        try {
            // const magaluTokenUrl = 'https://api.magalu.com.br/auth/token';
            const requestData = {
                grant_type: 'authorization_code',
                client_id: '6PtLMI_2XwSS4mTCtdF8tw6lfSXEDo3NFan3oEnATsM', // Substitua com seu client_id do Magalu
                client_secret: 'OykbEEUfprz_vw5BnldBZkRwpt1NAijyhHZ8KSTycZM', // Substitua com seu client_secret do Magalu
                redirect_uri: 'https://ziphub.com.br/magalu', // URL de redirecionamento configurada no Magalu
                code: code,
                seller_id: seller,
            };

            const response = await apinode.post(`/magalu/${localStorage.idconta}`, requestData);
            console.log('Token de acesso:', response.data);
            toast.success(response.data.message)
            // Faça o que for necessário com o token de acesso obtido
        } catch (error) {
            toast.error(error.message)
            console.error('Erro ao obter token de acesso:', error.message);
        }
    };

    return (
        <>
            <Navbar />
            <div className="container mt-page">
                <div className="row justify-content-center">
                    <div className="col-md-6">
                        <div className="card">
                            <div className="card-body">
                                <h3 className="card-title text-center">Magalu Authentication</h3>
                                <p className="text-center">Extraindo código da URL...</p>
                                <div className="text-center">
                                    <button className="btn btn-primary" onClick={handleAuthentication}>
                                        Continuar
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default MagaluAuthentication;
